module.exports = __webpack_public_path__ + "img/logo-footer-2.85577a72.png";